import React from 'react'

function YoutubeDetails({ selectedSubCategory, youtube }) {
	return (
		<>
			{((selectedSubCategory === "YoutubeVideo" || selectedSubCategory === "YoutubeCustomComments") && youtube?.contentType === "video") ? <div>
				<div className='flex flex-row justify-normal  '>
					<img className='rounded-md ' src={youtube?.thumbnailUrl} alt="thumbnail"></img>
					<div className='flex flex-col mx-5'>
						<div className=' font-semibold my-5'>{youtube?.videoTitle}</div>
						<div className='flex flex-row justify-normal gap-2 '>
							<div>Views: <span className='font-semibold'>{youtube?.viewCount}</span> </div>
							<div>Likes: <span className='font-semibold'>{youtube?.likeCount}</span>  </div>
							<div>Comments: <span className='font-semibold'>{youtube?.commentCount}</span> </div>
						</div>
					</div>
				</div>

			</div> : null}
			{(selectedSubCategory === "YoutubeChannel" && youtube?.contentType === "channel") ? <div>
				<div className='flex flex-row justify-normal '>
					<img className='rounded-md' src={youtube?.thumbnailUrl} alt="thumbnail"></img>
					<div className='flex flex-col mx-5'>
						<div className=' font-semibold my-5'> {youtube?.channelTitle} </div>
						<div className='flex flex-row justify-normal gap-2'>
							<div>Subscirbers: <span className='font-semibold'>{youtube?.subscribersCount}</span></div>
							<div>Views: <span className='font-semibold'> {youtube?.viewCount}</span></div>
							<div>Videos: <span className='font-semibold'>{youtube?.videosCount}</span></div>

						</div>
					</div>
				</div>
			</div> : null}
		</>
	)
}

export default YoutubeDetails